<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="reviews">
    <h1 style="color: var(--text-color); margin-top: 20px;">Recensioni</h1>
    <h2 class="title"><span><img
          src="http://ajgw3us0nspzo7gytwy4g381.79.143.179.101.sslip.io/uploads/1777738547022-tripadvisor-logo-circle-owl-icon-black-green-858x858.png"></span>
      Tripadvisor</h2>
    <h3 class="subtitle">Cosa dicono di noi...</h3>
    <h3 class="score">Punteggio: <div class="rating">
        <span v-for="(index, i) in 5" :key="i" class="circle" :style="{ width: i === 5 ? '5px' : '20px' }"></span>
        <span class="cut-circle">&nbsp;&nbsp;&nbsp;&nbsp;</span>
      </div>
    </h3>
    <div v-for="(review, index) in reviews" :key="index" class="review">
      <div class="review-header">
        <img :src="review.profileImage" alt="Profile Image" class="profile-image">
        <div class="review-info">
          <h3 class="review-name">{{ review.name }} <span class="review-rating">
              <span v-for="star in review.stars" :key="star" class="star"></span>
            </span></h3>
        </div>
      </div>
      <p class="review-text">{{ review.text }}</p>
    </div>
    <a href="https://www.tripadvisor.it/UserReviewEdit-g2337487-d15922260-Sapori_Miei-Vairano_Patenora_Province_of_Caserta_Campania.html/" class="leave-review-btn">Lascia una recensione</a>
  </div>
</template>

<script>
import { gsap } from "gsap";

export default {
  data() {
    return {
      reviews: [
        {
          name: "Fearless47517317033",
          profileImage: "https://media-cdn.tripadvisor.com/media/photo-l/2b/50/35/28/caption.jpg",
          stars: 5,
          text: "Pizza deliziosa ingredienti di alta qualità e impasto leggerissimo. Servizio attento e personale professionale. Prezzi giustissimi. L'unica cosa che potrei consigliare è di aumentare un po' la luminosità della sala. Nonostante ciò, sicuramente tornerò perché merita tanto"
        },
        {
          name: "Otravez",
          profileImage: "https://media-cdn.tripadvisor.com/media/photo-l/1a/f6/e3/6a/default-avatar-2020-47.jpg",
          stars: 5,
          text: "Sempre un piacere ritornare in questo locale, è come sentirsi a casa a partire dalla cordialità e gentilezza . I prodotti sempre freschi e genuini, una cucina semplice ma dal gusto inconfondibile... tutto ottimo come sempre ... a presto ragazzi . Grazie"
        }
      ]
    };
  },
  mounted() {
    gsap.to(".leave-review-btn", {
      duration: 0.5,
      scale: 1.1,
      yoyo: true,
      repeat: -1,
      ease: "power1.inOut",
    });
  },
};
</script>

<style scoped>
.reviews {
  display: flex;
  flex-direction: column;
}

.title {
  color: var(--text-color);
  text-align: center;
  font-size: 24px;
  margin: 30px;
  margin-bottom: 10px;
}

.title span img {
  height: 60px;
  border-radius: 30px;
}

.subtitle {
  color: var(--text-color);
  text-align: center;
  font-size: 18px;
  margin-bottom: 20px;
}

.review {
  border-radius: 8px;
  padding: 20px;
  margin: 15px;
  margin-bottom: 20px;
  background-color: var(--primary-color);
  box-shadow: var(--custom-box-shadow);
  color: var(--text-color);
}

.review-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.score {
  color: var(--text-color);
}

.profile-image {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 10px;
}

.review-info {
  position: relative;
  top: -15px;
}

.review-name {
  margin: 0;
  font-size: 16px;
}

.review-rating {
  margin-top: 5px;
}

.star {
  width: 10px;
  height: 10px;
  background-color: #33E0A1;
  /* Colore delle palline verdi */
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}

.review-text {
  margin: 0;
  font-size: 14px;
}

.leave-review-btn {
  align-self: center;
  padding: 10px 20px;
  background-color: var(--accent-color);
  color: var(--text-color);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
  text-decoration: none;
  /* Rimuove la sottolineatura */
  display: inline-block;
  transition: background-color 0.3s ease;
}

.leave-review-btn:hover {
  background-color: var(--accent-color-clicked);
}

.rating {
  display: inline-block;
  position: relative;
  top: 3px;
}

.circle {
  height: 20px;
  border-radius: 50%;
  background-color: #33E0A1;
  /* Colore delle palline verdi */
  display: inline-block;
  margin-right: 5px;
}

.cut-circle {
  height: 40px;
  width: 40px;
  background-color: var(--background-color);
  position: relative;
  left: -13px;
}
</style>
